import { render } from "./CBeloteHeader.vue?vue&type=template&id=2c28d65f&scoped=true"
const script = {}

import "./CBeloteHeader.vue?vue&type=style&index=0&id=2c28d65f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c28d65f"]])

export default __exports__